import "../../styles/Leaderboard.css";
import gold from "../../images/gold.png";
import silver from "../../images/silver.png";
import bronze from "../../images/bronze.png";
import profile1 from "../../images/bird1.svg";
import profile2 from "../../images/bird2.svg";
import profile3 from "../../images/bird3.svg";
import profile4 from "../../images/bird4.svg";
import { useData } from "../../providers/ContextProvider";
import { ReactComponent as StreakIcon } from "../../images/fire.svg";
import { ReactComponent as XPIcon } from "../../images/tick.svg";

function Leaderboard() {
  const { state, dispatch } = useData();
  const { userStats, leaderboard, userID } = state;

  function getAvatar(avatarName) {
    switch (avatarName) {
      case "bird1":
        return profile1;
      case "bird2":
        return profile2;
      case "bird3":
        return profile3;
      case "bird4":
        return profile4;
      default:
        return profile2;
    }
  }
  return (
    <main className="main leaderboard">
      <div className="leaderboard-header">
        <div className="shields">
          <div className="shield-img-container">
            <img
              src={silver}
              alt="bronze"
              className={
                userStats.currentLeague === "bronze"
                  ? "shield-img current-league"
                  : "shield-img"
              }
            />
            <div className="shield-no">3</div>
            <div className="shield-name">Bronze</div>
          </div>
          <div className="days-left-indicator">
            <span className="emphasis">1</span> days left
          </div>
        </div>
        <div className="info-container">
          <div>
            <span className="current-league-label">Current League</span>
            <span className="current-league-value">
              {userStats.currentLeague.toUpperCase()}
            </span>
          </div>
          <div className="info">
            Top 10 advance to the next league at the end of the week!
          </div>
        </div>
      </div>
      <div className="top-scorers">
        <div className="top-scorers-heading">Top Scorers</div>
        <div className="scorers-container">
          {leaderboard[userStats.currentLeague].slice(0, 3).map((leader) => (
            <div className="scorer" key={leader.userID}>
              <img
                src={getAvatar(leader.avatar)}
                alt="profile1"
                className="scorer-img"
              />
              <div className="scorer-card">
                <div className="scorer-name">{leader.name}</div>
                <div className="scorer-stats">
                  <span className="scorer-stats-label">XP</span>
                  <span className="scorer-stats-value">{leader.XP}</span>
                </div>
                <div className="scorer-stats">
                  <span className="scorer-stats-label">Streaks</span>
                  <span className="scorer-stats-value">{leader.streaks}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="scorer-tab-list">
        {leaderboard[userStats.currentLeague].map((leader) => (
          <div
            className={
              leader.userID === userID
                ? "current-user-tab scorer-tab"
                : "scorer-tab"
            }
            key={leader.userID}
          >
            <img
              src={getAvatar(leader.avatar)}
              alt="profile1"
              className="scorer-tab-img"
            />
            <div className="scorer-tab-name">{leader.name}</div>
            <div className="scorer-tab-stats">
              <span className="scorer-tab-stats-value">
                <XPIcon />
                {leader.XP}
              </span>
              <span className="scorer-tab-stats-value">
                <StreakIcon className="scorer-tab-icon" />
                {leader.streaks}
              </span>
            </div>
          </div>
        ))}
      </div>
    </main>
  );
}

export default Leaderboard;
